<template>
  <div>
    ©2013－2020 DataCastle蜀ICP备17028166号-1
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
div {
  width: 100%;
  height: 68px;
  background: #002352;
  position: fixed;
  bottom: 0;
  text-align: center;
  line-height: 68px;
  font-size: 12px;
  font-weight: 400;
  color: #B4BAC1;
}
</style>
